<div>
  <h1 class="title">Validation des documents importants</h1>
  <h5 class="title-text-muted text-muted fs-16">
    <!-- Veuillez télécharger vos documents professionnel. Nous vérifions
    l'authenticité de ces informations pour garantir l'intégrité de votre profil
    professionnel. -->
    Vos documents à envoyer
  </h5>
  <div class="mt-px-16">
    <app-custom-drop-down
      [parentForm]="form"
      controlName="nationality"
      class="prefixe-class"
      [label]="'Votre nationalité'"
      [options]="nationalityOptions"
      [required]="false"
      [simpleDropDown]="true"
    ></app-custom-drop-down>
  </div>

  <div class="p-px-40">
    <div>
      <app-text-separator text="identité"></app-text-separator>
      @if(form.get('nationality')?.value == 'autre'){
      <app-upload-file
        class="mt-px-16"
        label="Passeport"
        [files]="
          this.candidatBody?.passeport
            ? [
                {
                  file: this.candidatBody?.passeport,
                  url: this.candidatBody?.passeportUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'passport')"
        (deleteFile)="deleteFile($event, 'passport')"
        [required]="true"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Titre de séjour (Recto)"
        [files]="
          this.candidatBody?.bankDetails
            ? [
                {
                  file: this.candidatBody?.sejourFace,
                  url: this.candidatBody?.sejourFaceUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'sejourFace')"
        (deleteFile)="deleteFile($event, 'sejourFace')"
        [required]="true"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Titre de séjour (Verso)"
        [files]="
          this.candidatBody?.sejourBack
            ? [
                {
                  file: this.candidatBody?.sejourBack,
                  url: this.candidatBody?.sejourBackUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'sejourBack')"
        (deleteFile)="deleteFile($event, 'sejourBack')"
        [required]="true"
      ></app-upload-file>
      }
      @else if(form.get('nationality')?.value == 'Française')
      { @if(identityCart.get('value')?.value == 1){
      <div _ngcontent-ng-c2590467736="" class="fs-13 fw-6 text-neutral-dark mb-px-4 pt-px-16 ng-star-inserted">
        Carte d’identité
      </div>
      <app-upload-file [parentForm]="identityCart" [options]="identityCartOpt" [hasDropDown]="true"
        (sendFile)="getFile($event, 'idFace')" class="mt-px-16" [required]="true" label="Votre pièce d’identité (Recto)"
        [files]="
                this.candidatBody?.idFace
                  ? [
                      {
                        file: this.candidatBody?.idFace,
                        url: this.candidatBody?.idFaceUrl
                      }
                    ]
                  : []
              " (deleteFile)="deleteFile($event, 'idFace')"></app-upload-file>
      <app-upload-file [parentForm]="identityCart" (sendFile)="getFile($event, 'idBack')" class="mt-px-16"
        label="Votre pièce d’identité (Verso)" (deleteFile)="deleteFile($event, 'idBack')" [files]="
                this.candidatBody?.idBack
                  ? [
                      {
                        file: this.candidatBody?.idBack,
                        url: this.candidatBody?.idBackUrl
                      }
                    ]
                  : []
              " [required]="true"></app-upload-file>
      }@else {
      <app-upload-file [parentForm]="identityCart" [options]="identityCartOpt" [hasDropDown]="true"
        (sendFile)="getFile($event, 'passport')" class="mt-px-16" [files]="
                this.candidatBody?.passport
                  ? [
                      {
                        file: this.candidatBody?.passport,
                        url: this.candidatBody?.passportUrl
                      }
                    ]
                  : []
              " label="Passeport" [required]="true" (deleteFile)="deleteFile($event, 'passport')"></app-upload-file>
      } }
      @else { @if(identityCart.get('value')?.value == 1){
      <div
        _ngcontent-ng-c2590467736=""
        class="fs-13 fw-6 text-neutral-dark mb-px-4 pt-px-16 ng-star-inserted"
      >
        Carte d’identité
      </div>
      <app-upload-file
        [parentForm]="identityCart"
        [options]="identityCartOpt"
        [hasDropDown]="true"
        (sendFile)="getFile($event, 'idFace')"
        class="mt-px-16"
        [required]="true"
        label="Votre pièce d’identité (Recto)"
        [files]="
          this.candidatBody?.idFace
            ? [
                {
                  file: this.candidatBody?.idFace,
                  url: this.candidatBody?.idFaceUrl
                }
              ]
            : []
        "
        (deleteFile)="deleteFile($event, 'idFace')"
      ></app-upload-file>
      <app-upload-file
        [parentForm]="identityCart"
        (sendFile)="getFile($event, 'idBack')"
        class="mt-px-16"
        label="Votre pièce d’identité (Verso)"
        (deleteFile)="deleteFile($event, 'idBack')"
        [files]="
          this.candidatBody?.idBack
            ? [
                {
                  file: this.candidatBody?.idBack,
                  url: this.candidatBody?.idBackUrl
                }
              ]
            : []
        "
        [required]="true"
      ></app-upload-file>
      }@else {
      <app-upload-file
        [parentForm]="identityCart"
        [options]="identityCartOpt"
        [hasDropDown]="true"
        (sendFile)="getFile($event, 'passport')"
        class="mt-px-16"
        [files]="
          this.candidatBody?.passport
            ? [
                {
                  file: this.candidatBody?.passport,
                  url: this.candidatBody?.passportUrl
                }
              ]
            : []
        "
        label="Passeport"
        [required]="true"
        (deleteFile)="deleteFile($event, 'passport')"
      ></app-upload-file>
      } }
      <app-text-separator
        text="RELEVE D’IDENTITE BANCAIRE"
        innerClass="mt-px-32"
      ></app-text-separator>
      <app-upload-file
        class="mt-px-16"
        label="Relevé d’identité bancaire"
        [files]="
          this.candidatBody?.bankDetails
            ? [
                {
                  file: this.candidatBody?.bankDetails,
                  url: this.candidatBody?.bankDetailsUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'bankDetails')"
        (deleteFile)="deleteFile($event, 'bankDetails')"
      ></app-upload-file>
      <app-text-separator text="ASSURANCE MALADIE"></app-text-separator>
      <app-upload-file
        class="mt-px-16"
        label="Carte vitale ou attestation de sécurité sociale"
        (sendFile)="getFile($event, 'socialSecurityCertif')"
        [files]="
          this.candidatBody?.socialSecurityCertif
            ? [
                {
                  file: this.candidatBody?.socialSecurityCertif,
                  url: this.candidatBody?.socialSecurityCertifUrl
                }
              ]
            : []
        "
        (deleteFile)="deleteFile($event, 'socialSecurityCertif')"
      ></app-upload-file>
      <app-text-separator text="JUSTIFICATIF DE DOMICILE"></app-text-separator>
      @if(justificatifDomicile.get('value')?.value == 1){

      <app-upload-file
        class="mt-px-16"
        label="Pièce d'identité de la personne qui vous héberge"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [hasSecDropDown]="true"
        [required]="true"
        [files]="
          this.candidatBody?.letterSignedByHost
            ? [
                {
                  file: this.candidatBody?.letterSignedByHost,
                  url: this.candidatBody?.letterSignedByHostUrl
                }
              ]
            : []
        "
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'letterSignedByHost')"
        (deleteFile)="deleteFile($event, 'letterSignedByHost')"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Lettre de l’hébergeant signée certifiant que vous habitez chez lui"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [options2]="justificatifDomicileOptn2"
        [files]="
          this.candidatBody?.justificatifDomicileHost
            ? [
                {
                  file: this.candidatBody?.justificatifDomicileHost,
                  url: this.candidatBody?.justificatifDomicileHostUrl
                }
              ]
            : []
        "
        [required]="true"
        (sendFile)="getFile($event, 'justificatifDomicileHost')"
        (deleteFile)="deleteFile($event, 'justificatifDomicileHost')"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Justificatif de domicile de moins d'un an au nom de l’hébergeant"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [options2]="justificatifDomicileOptn2"
        [required]="true"
        [files]="
          this.candidatBody?.justificatifDomicile
            ? [
                {
                  file: this.candidatBody?.justificatifDomicile,
                  url: this.candidatBody?.justificatifDomicileUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'justificatifDomicile')"
        (deleteFile)="deleteFile($event, 'justificatifDomicile')"
      ></app-upload-file>
      }@else { @if(justificatifDomicile2.get('value')?.value == 1){
      <app-upload-file
        class="mt-px-16"
        label="Facture de téléphone"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [hasSecDropDown]="true"
        [required]="true"
        [files]="
          this.candidatBody?.phoneBill
            ? [
                {
                  file: this.candidatBody?.phoneBill,
                  url: this.candidatBody?.phoneBillUrl
                }
              ]
            : []
        "
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'phoneBill')"
        (deleteFile)="deleteFile($event, 'phoneBill')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 2){
      <app-upload-file
        class="mt-px-16"
        label="Facture d'électricité ou de gaz"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [required]="true"
        [hasSecDropDown]="true"
        [files]="
          this.candidatBody?.electroBill
            ? [
                {
                  file: this.candidatBody?.electroBill,
                  url: this.candidatBody?.electroBillUrl
                }
              ]
            : []
        "
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'electroBill')"
        (deleteFile)="deleteFile($event, 'electroBill')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 3){
      <app-upload-file
        class="mt-px-16"
        label="Quittance de loyer émanant d'un organisme social ou d'une agence immobilière"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [files]="
          this.candidatBody?.quittanceImmob
            ? [
                {
                  file: this.candidatBody?.quittanceImmob,
                  url: this.candidatBody?.quittanceImmobUrl
                }
              ]
            : []
        "
        [hasSecDropDown]="true"
        [required]="true"
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'quittanceImmob')"
        (deleteFile)="deleteFile($event, 'quittanceImmob')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 4){
      <app-upload-file
        class="mt-px-16"
        label="Titre de propriété"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [hasSecDropDown]="true"
        [required]="true"
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'propertyTitle')"
        [files]="
          this.candidatBody?.propertyTitle
            ? [
                {
                  file: this.candidatBody?.propertyTitle,
                  url: this.candidatBody?.propertyTitleUrl
                }
              ]
            : []
        "
        (deleteFile)="deleteFile($event, 'propertyTitle')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 5){
      <app-upload-file
        class="mt-px-16"
        label="Facture d'eau"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [required]="true"
        [files]="
          this.candidatBody?.waterBill
            ? [
                {
                  file: this.candidatBody?.waterBill,
                  url: this.candidatBody?.waterBillUrl
                }
              ]
            : []
        "
        [hasSecDropDown]="true"
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'waterBill')"
        (deleteFile)="deleteFile($event, 'waterBill')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 6){
      <app-upload-file
        class="mt-px-16"
        label="Avis d’imposition ou certification de non imposition"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [required]="true"
        [files]="
          this.candidatBody?.certImpos
            ? [
                {
                  file: this.candidatBody?.certImpos,
                  url: this.candidatBody?.certImposUrl
                }
              ]
            : []
        "
        [hasSecDropDown]="true"
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'certImpos')"
        (deleteFile)="deleteFile($event, 'certImpos')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 7){
      <app-upload-file
        class="mt-px-16"
        label="Justificatif de taxe d’habitation ou de taxe foncière"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [files]="
          this.candidatBody?.taxBill
            ? [
                {
                  file: this.candidatBody?.taxBill,
                  url: this.candidatBody?.taxBillUrl
                }
              ]
            : []
        "
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [hasSecDropDown]="true"
        [required]="true"
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'taxBill')"
        (deleteFile)="deleteFile($event, 'taxBill')"
      ></app-upload-file>
      } @if(justificatifDomicile2.get('value')?.value == 8){
      <app-upload-file
        class="mt-px-16"
        label="Attestation ou facture d'assurance du logement"
        [parentForm]="justificatifDomicile"
        [options]="justificatifDomicileOptn"
        [secParentForm]="justificatifDomicile2"
        [hasDropDown]="true"
        [files]="
          this.candidatBody?.assuranceLogement
            ? [
                {
                  file: this.candidatBody?.assuranceLogement,
                  url: this.candidatBody?.assuranceLogementUrl
                }
              ]
            : []
        "
        [hasSecDropDown]="true"
        [required]="true"
        [options2]="justificatifDomicileOptn2"
        (sendFile)="getFile($event, 'assuranceLogement')"
        (deleteFile)="deleteFile($event, 'assuranceLogement')"
      ></app-upload-file>
      } }

      <app-text-separator
        text="Carte grise de votre véhicule"
        innerClass="mt-px-32"
      ></app-text-separator>
      <app-upload-file
        class="mt-px-16"
        label="Carte grise de votre véhicule"
        [files]="
          this.candidatBody?.cv
            ? [
                {
                  file: this.candidatBody?.carteGrise,
                  url: this.candidatBody?.carteGriseUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'carteGrise')"
        (deleteFile)="deleteFile($event, 'carteGrise')"
      ></app-upload-file>
      <app-text-separator
        text="Assurances responsabilité professionnelle si vous en disposez"
        innerClass="mt-px-32"
      ></app-text-separator>
      <app-upload-file
        class="mt-px-16"
        label="Assurances responsabilité professionnelle si vous en disposez"
        [files]="
          this.candidatBody?.insuranceResponsibility
            ? [
                {
                  file: this.candidatBody?.insuranceResponsibility,
                  url: this.candidatBody?.insuranceResponsibilityUrl
                }
              ]
            : []
         " (sendFile)="getFile($event, 'enrollmentCertificate')"
              (deleteFile)="deleteFile($event, 'enrollmentCertificate')"
      ></app-upload-file>

      <app-text-separator
        text="Profession"
        innerClass="mt-px-32"
      ></app-text-separator>
      <app-upload-file
        class="mt-px-16"
        label="Votre CVs"
        [required]="true"
        [files]="
          this.candidatBody?.cv
            ? [
                {
                  file: this.candidatBody?.cv,
                  url: this.candidatBody?.cvUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'cv')"
        (deleteFile)="deleteFile($event, 'cv')"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Diplôme principal"
        [required]="true"
        [files]="
          this.candidatBody?.firstDiplome
            ? [
                {
                  file: this.candidatBody?.firstDiplome,
                  url: this.candidatBody?.firstDiplomeUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'firstDiplome')"
        (deleteFile)="deleteFile($event, 'firstDiplome')"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Autre diplôme (Deuxième)"
        [files]="
          this.candidatBody?.secondDiplome
            ? [
                {
                  file: this.candidatBody?.secondDiplome,
                  url: this.candidatBody?.secondDiplomeUrl
                }
              ]
            : []
        "
        (sendFile)="getFile($event, 'secondDiplome')"
        (deleteFile)="deleteFile($event, 'secondDiplome')"
      ></app-upload-file>
      <app-upload-file
        class="mt-px-16"
        label="Autre diplôme (Troisième)"
        (sendFile)="getFile($event, 'thirdDiplome')"
        [files]="
          this.candidatBody?.thirdDiplome
            ? [
                {
                  file: this.candidatBody?.thirdDiplome,
                  url: this.candidatBody?.thirdDiplomeUrl
                }
              ]
            : []
        "
        (deleteFile)="deleteFile($event, 'thirdDiplome')"
      ></app-upload-file>
      <div class="my-px-16" [formGroup]="form">
        <mat-label>Date de l’obtention de votre diplôme
          <span class="required">*</span>
        </mat-label>
        <input class="form-control py-px-12" formControlName="graduationYear" placeholder="Sélectionner" type="date"
          [defaultValue]="form.get('graduationYear')?.value" />
      </div>
    </div>
  </div>
</div>
<div class="mt-px-16">
  <app-button
    color="primary"
    [text]="
      documentFormGroup.invalid
        ? 'Plus tard'
        : 'Soumettre les documents et continuer'
    "
    (handleClick)="documentFormGroup.valid ? submitDocument() : onSubmit.emit()"
    class="mx-auto text-center"
    [innerClass]="'p-3 w-100'"
  ></app-button>
  <h5 class="title-text-muted text-muted fs-16 mt-px-16 text-center">
    Ces informations sont importantes pour pouvoir postuler à des missions.
  </h5>
</div>
